"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_FONT_FAMILY = void 0;
exports.DEFAULT_FONT_FAMILY = '"Inter UI", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"';
//# sourceMappingURL=default_theme_attributes.js.map